export const ROUTES = {
  passengerDetails: "/air/travel-ready/passenger-details",
  passengers: "/air/travel-ready/passengers",
  passportVerify: "/air/travel-ready/passport-verify",
  residentCardVerify: "/air/travel-ready/resident-card-verify",
};
